import { IconButton, IconButtonProps, Tooltip } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { forwardRef } from 'react';

import styles from './sidebarIconButton.module.scss';

type SidebarIconButtonProps = IconButtonProps & {
  /** Shown as the tooltip and used as the accessible name. */
  label: string;
  hideTooltip?: boolean;
};

export const SidebarIconButton = forwardRef<
  HTMLButtonElement,
  SidebarIconButtonProps
>(function SidebarIconButton(
  { className, label, hideTooltip, ...iconButtonProps },
  ref,
) {
  const button = (
    <IconButton
      ref={ref}
      variant="tertiary"
      aria-label={label}
      {...iconButtonProps}
      className={classnames(styles.root, className)}
    />
  );

  return hideTooltip ? button : <Tooltip content={label}>{button}</Tooltip>;
});
